import { Button } from '@frontend/design_system'
import { SUBMIT } from 'texts/common'
import { CANCEL, SAVE } from 'texts/uiTexts'
import { FormActionButtonsProps } from './types'
import styles from './styles.module.scss'
import { formIsDirtySelector } from 'redux/forms/selectors'
import { useSelector } from 'react-redux'
import { isOperatorSelector } from 'redux/login/selectors'

export const FormActionButtons = ({
  handleBack,
  loading,
  isProfileNotCompleted,
  submitButtonLabel = SAVE,
  submitButtonLoading,
  formId,
}: FormActionButtonsProps) => {
  const isDirty = useSelector(formIsDirtySelector(formId))
  const isOperator = useSelector(isOperatorSelector)
  const renderButtons = () => {
    if (!isProfileNotCompleted) {
      return (
        <div className={styles.buttons}>
          <div className={styles['button-wrapper']}>
            <Button
              variant="secondary-border"
              onClick={handleBack}
              label={CANCEL}
              disabled={!isDirty && !isOperator}
            />
          </div>
          <div className={styles['button-wrapper']}>
            <Button
              htmlType="submit"
              dataTestId="profile-details-form-save-button"
              label={submitButtonLabel}
              loading={loading}
              form={formId}
              disabled={!isDirty}
            />
          </div>
        </div>
      )
    } else {
      return (
        <div className={styles['complete-button']}>
          <Button
            htmlType="submit"
            label={SUBMIT}
            variant="green"
            loading={submitButtonLoading}
            form={formId}
            disabled={!isDirty}
          />
        </div>
      )
    }
  }
  return <div>{renderButtons()}</div>
}
